import {Button} from '@sollapay/ui/components';
import {cn} from '@sollapay/ui/lib';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface BuyerActionButtonProps {
  showRequestPayment: boolean;
  onRequestPayment: () => void;
  onViewBuyer: () => void;
  className?: string;
}

export const BuyerActionButton: FC<BuyerActionButtonProps> = ({
  showRequestPayment,
  onRequestPayment,
  onViewBuyer,
  className
}) => {
  const {t} = useTranslation('trustAccounts');

  if (showRequestPayment) {
    return (
      <Button
        variant="primary"
        size="sm"
        className={cn('w-32', className)}
        onClick={onRequestPayment}
      >
        {t('view.buyers.list.actions.requestPayment')}
      </Button>
    );
  }

  return (
    <Button variant="secondary" size="sm" className={cn('w-32', className)} onClick={onViewBuyer}>
      {t('view.buyers.list.actions.viewBuyer')}
    </Button>
  );
};
